import { hexToRgbA, getDarkenColor, getLightenColor } from './'

export default (type, colors) => {
  const styles = {
    default: {
      'button-dropdown__trigger': {
        boxShadow: `1px 1px 0 0 ${hexToRgbA(colors.secondary, 0.06)}`,
        customCSS: `
          .button-dropdown__trigger {
            background: ${colors.light};
            color: ${getDarkenColor(colors.primary, 0.17)};
          }
          .button-dropdown__trigger:hover,
          .button-dropdown__trigger:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
            background-color: ${getDarkenColor(colors.light, 0.02)};
            box-shadow: 1px 1px 0 0 ${getDarkenColor(getLightenColor(colors.secondary, 0.5), 0.05)};
          }
          .button-dropdown.state-expanded .button-dropdown__trigger {
            background-color: ${colors.secondary};
          }
        `
      },
      'button-dropdown': {
        customCSS: `
          .button-dropdown.state-expanded,
          .button-dropdown__dropdown--styled {
            background: ${colors.light};
          }
        `
      }
    },
    type1: {
      'button-dropdown__trigger': {
        background: 'transparent',
        boxShadow: 'none',
        customCSS: `
          .button-dropdown__trigger {
            color: ${getDarkenColor(colors.primary, 0.17)};
          }
          .button-dropdown__trigger:hover,
          .button-dropdown__trigger:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
            background-color: ${getDarkenColor(colors.secondary, 0.05)};
          }
          .button-dropdown.state-expanded .button-dropdown__trigger {
            background: transparent!important;
            color: ${colors.primary};
          }

          .button-dropdown__trigger:after {
            content: '\\EA07';
            font-family: moon-iconfont!important;
            position: absolute;
            right: -8px;
            top: 0;
            font-size: 10px;
            color: ${colors.primary};
          }
        `
      },
      'button-dropdown__text': {
        textTransform: 'uppercase',
        color: colors.primary,
        marginRight: '5px',
        fontSize: '0.83333rem',
        fontWeight: 'bold'
      },
      'button-dropdown__trigger-text': {
        fontSize: '24px',
        color: colors.primary
      },
      'button-dropdown': {
        customCSS: `
          .button-dropdown.state-expanded,
          .button-dropdown__dropdown--styled {
            background: transparent;
          }
          .button-dropdown__trigger-text:after {
            font-family: moon-iconfont !important;
            color: ${colors.primary};
            background-image: none;
            margin-left: 10px;
            content: "\\EA07";
            font-size: 12px;
            width: auto;
            height: auto;
          }
          select, select:hover {
            background-color: #fff;
          }
        `
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/buttonDropdown.js